import { FaArrowUp, FaArrowDown, FaCopy, FaTrash } from 'react-icons/fa';
import { useSiteConfigDispatch } from '../../context/SiteConfigContext';
import { useDeleteBlock } from '../../hooks/useDeleteBlock';
import { useT } from '../../hooks/useT';
import styles from './BlockControls.module.css';

function BlockControls({ block, pageKey, blockIndex, totalBlocks }) {
  const dispatch = useSiteConfigDispatch();
  const deleteBlock = useDeleteBlock();
  const t = useT();

  const handleMoveUp = (e) => {
    e.stopPropagation();
    if (blockIndex > 0) {
      dispatch({ type: 'MOVE_BLOCK', pageKey, fromIndex: blockIndex, toIndex: blockIndex - 1 });
    }
  };

  const handleMoveDown = (e) => {
    e.stopPropagation();
    if (blockIndex < totalBlocks - 1) {
      dispatch({ type: 'MOVE_BLOCK', pageKey, fromIndex: blockIndex, toIndex: blockIndex + 1 });
    }
  };

  const handleDuplicate = (e) => {
    e.stopPropagation();
    dispatch({ type: 'DUPLICATE_BLOCK', pageKey, blockId: block.id });
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    deleteBlock(pageKey, block.id);
  };

  return (
    <div className={styles.controls}>
      <button
        type="button"
        className={styles.btn}
        onClick={handleMoveUp}
        disabled={blockIndex === 0}
        aria-label={t('editor.moveUp', 'Move block up')}
        title={t('editor.moveUp', 'Move block up')}
      >
        <FaArrowUp />
      </button>
      <button
        type="button"
        className={styles.btn}
        onClick={handleMoveDown}
        disabled={blockIndex >= totalBlocks - 1}
        aria-label={t('editor.moveDown', 'Move block down')}
        title={t('editor.moveDown', 'Move block down')}
      >
        <FaArrowDown />
      </button>
      <button
        type="button"
        className={styles.btn}
        onClick={handleDuplicate}
        aria-label={t('editor.duplicate', 'Duplicate block')}
        title={t('editor.duplicate', 'Duplicate block')}
      >
        <FaCopy />
      </button>
      <button
        type="button"
        className={`${styles.btn} ${styles.deleteBtn}`}
        onClick={handleDelete}
        aria-label={t('editor.delete', 'Delete block')}
        title={t('editor.delete', 'Delete block')}
      >
        <FaTrash />
      </button>
    </div>
  );
}

export default BlockControls;
